import { AfterViewChecked, ChangeDetectorRef, Component, HostBinding, Inject, Input, OnDestroy } from '@angular/core';

import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { NavigationRouterService } from 'packages/sports/web/app/src/navigation/navigation-router.service';

import { BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN, IBetslipMessagesProviderService } from '../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../base/store/state';
import { BetslipType } from '../../../core/betslip-type';
import { BaseBetslipGroupPick } from '../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import BaseBetTypePickComponent from '../../picks/components/digital/base-bet-type-pick.component';
import { RemoveButtonStyle } from '../../picks/components/digital/pick-remove-button/remove-button-style';
import BetslipPickUtilsService from '../../picks/services/betslip-pick-utils.service';
import PickTypeSelectorService from '../../picks/services/pick-type-selector.service';
import { RemoveButtonPosition } from '../../single-bet/remove-button-position-enum';
import { IComboBetPickState } from '../state';

@Component({
    selector: 'bs-digital-combo-bet-pick',
    templateUrl: './combo-bet-pick.component.html',
    styleUrls: [
        '../../picks/components/digital/base-bet-type-pick.component.scss',
        './combo-bet-pick.component.scss',
        '../../picks/components/digital/base-bet-type-pick.component.linear.scss',
    ],
    standalone: false,
})
export default class ComboBetPickComponent extends BaseBetTypePickComponent implements AfterViewChecked, OnDestroy {
    @HostBinding('class') get className(): string {
        let className = 'betslip-digital-pick betslip-combo-bet-pick';
        if (this.pick.highlighted && !this.isLinear) {
            className = className.concat(' highlighted');
        }

        return className;
    }

    @Input() override pick: BetslipPick;
    @Input() comboBetPickState: IComboBetPickState;
    @Input() comboBetState: { isEachWay: boolean };
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonPosition: RemoveButtonPosition;
    @Input() removeButtonStyle: RemoveButtonStyle;
    @Input() isLinear: boolean;

    @HostBinding('class.betslip-digital-pick--remove-visible') get isRemoveButtonVisible(): boolean {
        return this.removeButtonPosition !== RemoveButtonPosition.None;
    }

    betslipType = BetslipType.Combo;

    constructor(
        protected override store: Store<IBetslipRootState>,
        pickTypeSelector: PickTypeSelectorService,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        navigationRouter: NavigationRouterService,
        redirectHelper: RedirectHelperService,
        changeDetectorRef: ChangeDetectorRef,
        betslipPickUtilsService: BetslipPickUtilsService,
    ) {
        super(store, pickTypeSelector, messageProvider, navigationRouter, redirectHelper, changeDetectorRef, betslipPickUtilsService);
    }

    override ngAfterViewChecked(): void {
        this.startRemoveTimer$.next(!this.isLinear && (this.pick.highlighted || this.hasHighlight));
    }

    override removeHighlight(): void {
        super.removeHighlight();
        this.pick.highlighted = false;
    }

    get isNotGroup() {
        return !BaseBetslipGroupPick.isPick(this.pick);
    }
}
